/**
 * @generated SignedSource<<4824f62437604ac53e42b2828a4d1182>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionWarningConfigState = "DISABLED" | "ENABLED" | "NOT_APPLICABLE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type issueProgressDetails_versionProgress$data = {
  readonly doneIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly inProgressIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly todoIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly warningConfig: {
    readonly failingBuild: JiraVersionWarningConfigState | null | undefined;
    readonly openPullRequest: JiraVersionWarningConfigState | null | undefined;
    readonly openReview: JiraVersionWarningConfigState | null | undefined;
    readonly unreviewedCode: JiraVersionWarningConfigState | null | undefined;
  } | null | undefined;
  readonly warningsCount: AGG$Long;
  readonly " $fragmentType": "issueProgressDetails_versionProgress";
};
export type issueProgressDetails_versionProgress$key = {
  readonly " $data"?: issueProgressDetails_versionProgress$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueProgressDetails_versionProgress">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "totalCount"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueProgressDetails_versionProgress",
  "selections": [
    {
      "concreteType": "JiraVersionWarningConfig",
      "kind": "LinkedField",
      "name": "warningConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "failingBuild"
        },
        {
          "kind": "ScalarField",
          "name": "openPullRequest"
        },
        {
          "kind": "ScalarField",
          "name": "openReview"
        },
        {
          "kind": "ScalarField",
          "name": "unreviewedCode"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "doneIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "DONE"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "doneIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
      },
      "action": "THROW",
      "path": "doneIssuesRedesignTemp"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "inProgressIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "IN_PROGRESS"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "inProgressIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
      },
      "action": "THROW",
      "path": "inProgressIssuesRedesignTemp"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "todoIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "TODO"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "todoIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
      },
      "action": "THROW",
      "path": "todoIssuesRedesignTemp"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "warningsCount"
      },
      "action": "THROW",
      "path": "warningsCount"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "d8f802ed4e1d73fb8f14bafb9265439b";

export default node;
